import {
  AvailabilityPayload,
  DailyAvailability,
  Holiday,
  UserAvailability,
} from "@/interfaces/Availability";
import api from "@/services/api";

export const availabilityApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUserAvailability: build.query<UserAvailability, string>({
      query: (userId) => `/users/${userId}/availability`,
      providesTags: (_result, _error, userId) => [
        { type: "Availabilities", id: userId },
      ],
    }),
    updateUserAvailability: build.mutation<
      UserAvailability,
      { userId: string; body: AvailabilityPayload }
    >({
      query: ({ userId, body }) => ({
        url: `/users/${userId}/availability`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { userId }) => [
        { type: "CommercialBooking", id: "LIST" },
        { type: "Availabilities", id: userId },
        { type: "Availabilities", id: "LIST" },
        { type: "Users", id: userId },
        { type: "Users", id: "LIST" },
        { type: "MontageMeetings" },
        { type: "Meetings", id: "LIST" },
        { type: "CompanyMeetings" },
      ],
    }),
    getAvailability: build.query<
      DailyAvailability[],
      { userIds: string[]; from: string; to: string }
    >({
      query: ({ userIds, from, to }) => ({
        url: "/availability",
        params: { userIds: userIds.join(","), from, to },
      }),
      providesTags: [{ type: "Availabilities", id: "LIST" }],
    }),
    getHolidays: build.query<Holiday[], number[]>({
      query: (years) => ({
        url: "/holidays",
        params: { years: years.join(",") },
      }),
      providesTags: ["Holidays"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetUserAvailabilityQuery,
  useUpdateUserAvailabilityMutation,
  useGetAvailabilityQuery,
  useGetHolidaysQuery,
} = availabilityApi;
